<script>
    export let data;
</script>

<div class="desktop">
    <div style="width: 88.815vw;margin:12vw auto 7vw;padding:0 1vw;">
        <div style="display: flex;">
            <h1
                style="color: rgb(0, 32, 75);
                font-size: 1.191vw;
                margin-right: 9.001vw;
                margin-top: -1vw;
                opacity: 0.3;"
            >
                {data.number}
            </h1>
            <div class="circle">
                <h1
                    style="    color: rgb(0, 32, 75);
                    font-size: 1.985vw;
                    text-transform: uppercase;
                    margin-left: 8.466vw;font-weight: 500;"
                >
                    {data.title}
                </h1>
                <div style="         
                width: 50.354vw;
                margin-left: 15.989vw;
                margin-top: 2.447vw;
                color: rgba(0, 32, 75, 1);

            ">
                    <p style="    font-size: 1.455vw;
                    text-align: justify;letter-spacing: 0.04vw;
                    word-spacing: 0.09vw;">
                        {data.description}
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="mobile">
    <div style="margin-bottom:10vw;margin-top:24.766vw;">
        <div style="display: flex;">
            <h1
                style="color:rgba(0, 32, 75, 1);font-size:2.778vw;margin-left: 5vw;;opacity: 0.3;"
            >
                {data.number}
            </h1>
            <div class="circle_mbl">
                <h1
                    style="color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight: 600; text-transform: uppercase;width: 80vw; margin-left: -10vw; margin-top: 7vw;"
                >
                    {data.title}
                </h1>
                <div style="width: 81.386vw;margin: 4vw 0px 0px -7.5vw;">
                    <p style="font-size: 3.056vw;line-height:4.833vw;text-align:justify;">
                        {data.description}
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .circle {
        width: 59.166vw;
        height: 30.179vw;
        padding: 4vw 0 0 4vw;
        border: 0.199vw solid rgb(124 193 255 / 20%);;
        border-top-right-radius: 1vw;
        border-bottom-right-radius: 1vw;
        border-left: none;
        position: relative;
    }
    .circle::before {
        content: " ";
        position: absolute;
        top: -1.09vw;
        left: 2vw;
        height: 1.919vw;
        width: 1.919vw;
        background-color: rgba(247, 224, 95, 1);
        border-radius: 50%;
    }
    .circle_mbl {
        width: 68.389vw;
        height: 84.444vw;
        padding: 5vw 0 0 4vw;
        border: 0.833vw solid rgba(124, 193, 255, 1);
        border-top-right-radius: 8vw;
        border-bottom-right-radius: 8vw;
        border-left: none;
        position: relative;
        margin-left: 7vw;
        margin-top: 1vw;
    }
    .circle_mbl::before {
        content: " ";
        position: absolute;
        top: -2.5vw;
        left: 4vw;
        height: 3.919vw;
        width: 3.919vw;
        background-color: rgba(247, 224, 95, 1);
        border-radius: 50%;
    }
    .desktop {
        display: block;
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobile {
            display: block;
        }
    }
</style>
